import PropTypes from 'prop-types'

import { CONSULTANT_DOCTOR } from 'util/Constant/DatabaseFixedValueList'

const ConsultantDoctorPropType = PropTypes.oneOf(CONSULTANT_DOCTOR)

export default ConsultantDoctorPropType
